export function formatSchedulePersonName(lastName: string, firstName: string): string {
  return `${lastName} ${firstName}`.trim();
}
